import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { links } from '../../environments/common.config';

enum CelFooterSize {
    DESKTOP = "desktop",
    TABLET = "tablet",
    MOBILE = "mobile"
}

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    footerItems = {};
    footerClass = '';
    footerLeftDivClass = '';
    footerRightDivClass = '';
    copyrightClass = '';
    listClass = '';
    firstFooterLinkClass = '';
    footerLinkClass = '';
    lastFooterLinkClass = '';
    logoSrc = '../../assets/learning-system-logos/savvas-white.svg';
    passLocale = 'en';
    device = CelFooterSize.DESKTOP;
    currentYear: number = new Date().getFullYear();

    constructor(
        private readonly translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        @Inject('WINDOW') private readonly windowRef: Window
    ) {
    }

    ngOnInit(): void {
        this.initializePageLayout();
        if (this.getLocale()) {
            this.footerClass = this.device === CelFooterSize.MOBILE ? 'footer-container footer-container-mobile row-between' : 'footer-container row-between';
            this.footerLeftDivClass = this.device === CelFooterSize.TABLET ? 'left-container col-start left-container-tablet' : this.device === CelFooterSize.MOBILE ? 'left-container col-start left-container-mobile' : 'left-container row-start left-container-desktop';
            this.copyrightClass = this.device === CelFooterSize.MOBILE ? 'copyright-mobile' : 'copyright-desktop';
            this.listClass = this.device === CelFooterSize.MOBILE ? 'col-start links-mobile' : 'col-footer links-parent-container';
            this.firstFooterLinkClass = this.device === CelFooterSize.DESKTOP ? 'footer-link link-class-first border-right' : this.device === CelFooterSize.TABLET ? 'footer-link remove-padding' : 'footer-link mobile-link';
            this.footerLinkClass = this.device === CelFooterSize.MOBILE ? 'footer-link mobile-link' : 'footer-link border-right';
            this.lastFooterLinkClass = this.device === CelFooterSize.MOBILE ? 'footer-link mobile-link last-link' : 'footer-link last-link border-right';
            this.footerRightDivClass = this.device === CelFooterSize.MOBILE ? 'right-container col-start right-container-mobile' : 'right-container';
            this.footerItems = {
                copyRightText: this.translate.instant('footer.footerCopyright') + this.currentYear + this.translate.instant('footer.footerText'),
                revisionTag: this.translate.instant('footer.revisionTag'),
                userAgreement: {
                    url: links.userAgreementUrl,
                    label: this.translate.instant('footer.userAgreement')
                },
                privacyPolicy: {
                    url: links.privacyPolicyUrl,
                    label: this.translate.instant('footer.privacyPolicy')
                },
                credits: {
                    url: links.creditsUrl
                }
            };
        }
    }

    getLocale(): string {
        this.activatedRoute.queryParams.subscribe(params => {
            const queryParamLocale = params.locale;
            if (queryParamLocale) {
                this.passLocale = queryParamLocale;
            }
        });
        return this.passLocale;
    }

    @HostListener('window:resize', ['$event'])
    onResize(): void {
        this.initializePageLayout();
    }

    initializePageLayout(): void {
        this.device = CelFooterSize.TABLET;
        if (this.windowRef.innerWidth > 1023) {
            this.device = CelFooterSize.DESKTOP;
        } if (this.windowRef.innerWidth < 577) {
            this.device = CelFooterSize.MOBILE;
        }
    }

}
